module.exports = __webpack_public_path__ + "img/backoffice-onboarding-form.86280ec7.svg";